<app-sous-titre-bloc>
  {{ 'components.blocWheel.distance' | transloco }}
</app-sous-titre-bloc>
<div class="bloc-wheel">
  <ng-content/>
</div>
